<div #mapContainer></div>
@if (!(authFacade.mapsPluginAccepted$ | async)) {
<div class="tw-flex tw-justify-center tw-items-center tw-p-5">
  {{ 'monitoring.shipmentsTrackingMap.mapsPluginNotAccepted' | translate }}
</div>
}
